<section class = "confirm-dialog-section">
    <p-confirmDialog #confirm [key]="key()" [dismissableMask]="false">
        <ng-template pTemplate="message" let-message>
            <ng-content />
        </ng-template>
    </p-confirmDialog>
</section>